import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attachmentSlice'
})
export class AttachmentSlicePipe implements PipeTransform {

  transform(path: string): string {
    let name:string[]=path.split('\\');

    return name[name.length-1];
  }

}
